import { Injectable, computed, inject, signal } from "@angular/core";
import { AlertController } from "@ionic/angular";
import { Utils } from "@shared-utils/Utils";
import { Subscription, interval } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CodereTimerService {
  private isAlertAr = false;
  private timeAlertAr = 0;

  private SUBSCRIPTIONS: Subscription = new Subscription();
  private LOCAL_TIME = signal("");
  private SESSION_TIME = signal("");

  public get localTime() {
    return computed(() => {
      return this.LOCAL_TIME();
    });
  }

  public get sessionTime() {
    return computed(() => {
      return this.SESSION_TIME();
    });
  }

  private utils = inject(Utils);
  private alertController = inject(AlertController);

  constructor() {
    this.initAllTimers();
  }

  private initAllTimers() {
    this.initSessionTime();

    this.initLocalTime();
  }

  private initLocalTime() {
    this.SUBSCRIPTIONS.add(
      interval(1000).subscribe(() => {
        this.LOCAL_TIME.set(this.utils.getLocalTime());
      }),
    );
  }

  unsubscribeAllTimers() {
    this.SUBSCRIPTIONS.unsubscribe();
  }

  private initSessionTime() {
    this.SUBSCRIPTIONS.add(
      interval(1000).subscribe(() => {
        this.setSessionTime();
      }),
    );
  }

  private async setSessionTime() {
    if (this.utils.globalVars.user?.logged && this.utils.globalVars.sessionInitDate !== null) {
      const sessionTime: Date = this.getSessionTime();

      const hora = sessionTime.getUTCHours();
      const minutos = sessionTime.getMinutes();
      const minutosStr = minutos < 10 ? "0" + minutos.toString() : minutos.toString();
      const segundos =
        sessionTime.getSeconds() < 10
          ? "0" + sessionTime.getSeconds().toString()
          : sessionTime.getSeconds().toString();

      // Aviso de tiempo de juego en AR
      const usedTime: number = hora;

      if (!this.isAlertAr && this.utils.globalVars.licenseType === 33 && usedTime > this.timeAlertAr) {
        this.isAlertAr = true;
        this.timeAlertAr = hora;

        const alert = await this.alertController.create({
          backdropDismiss: false,
          cssClass: "alertAr",
          message: `
                    <img src="assets/global/img/argentina/timealert.gif"
                    alt="Tiempo jugado">`,
          buttons: [{ text: "10" }],
        });
        alert.present().then(() => {
          let i = 10;
          const btn: Element = alert.querySelector(".alert-button");
          const int1 = interval(1000).subscribe(() => {
            if (btn) {
              btn.innerHTML = "0" + --i;
            }
            if (i === 0) {
              int1.unsubscribe();
              this.isAlertAr = false;
              this.timeAlertAr = this.getSessionTime().getHours();
              alert.dismiss();
            }
          });
        });
      }
      this.SESSION_TIME.set(hora.toString() + ":" + minutosStr + ":" + segundos);
    } else {
      this.SESSION_TIME.set("");
    }
  }

  private getSessionTime(): Date {
    const now: Date = new Date();
    const init: Date = this.utils.globalVars.sessionInitDate;
    const sessionTimeResult = now.getTime() - init?.getTime();
    return new Date(sessionTimeResult);
  }
}
